import {
  ALargeSmall,
  Circle,
  Combine,
  Eraser,
  Grid2x2,
  Grid3x3,
  Lasso,
  MoveDiagonal,
  MousePointer2,
  MoveIcon,
  PaintBucket,
  PenLine,
  Pipette,
  Move,
  Slash,
  Sparkles,
  Spline,
  Square,
  SquareDashed,
  Blocks,
  Brush,
  ArrowRight,
  Droplets,
  Type,
  type LucideIcon,
} from 'lucide-react';
import { ToolId } from '../tools/types';
import { SectionId } from './sections';

export const TOOL_ICONS: Record<ToolId, LucideIcon> = {
  select: SquareDashed,
  lasso: Lasso,
  wand: Sparkles,
  move: Move,
  pencil: PenLine,
  brush: Brush,
  eraser: Eraser,
  text: Type,
  line: Slash,
  rect: Square,
  ellipse: Circle,
  box: Grid2x2,
  arrow: ArrowRight,
  fill: PaintBucket,
  gradient: Droplets,
  braille: Grid3x3,
  brailleLine: Spline,
  brailleRect: Combine,
  brailleEllipse: MoveDiagonal,
  widget: Blocks,
  eyedropper: Pipette,
};

/** Which tools each section offers, in the order they should be listed. */
export const SECTION_TOOLS: Partial<Record<SectionId, ToolId[]>> = {
  draw: ['pencil', 'brush', 'eraser', 'fill', 'braille', 'eyedropper'],
  select: ['select', 'lasso', 'wand', 'move', 'brush', 'pencil', 'eraser'],
  shapes: ['box', 'line', 'rect', 'ellipse', 'arrow', 'brailleLine', 'brailleRect', 'brailleEllipse'],
  text: ['text'],
  elements: ['widget'],
  color: ['gradient', 'eyedropper', 'fill'],
};

export const FALLBACK_ICONS = { MousePointer2, ALargeSmall, MoveIcon };
